import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../services/apiClient';


const useFetchData = (url, transformData, searchParams) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(window.location.search.toString());
  
  const memoizedTransformData = useCallback((data) => {
    return transformData ? transformData(data) : data;
  }, [transformData]);


  useEffect(() => {
    console.log('GETリクエスト送信')
    if (!url) return;
    // const params = new URLSearchParams(location.search.toString());
    const token = params.get('token');
    const userid = params.get('userid');

    if (token && userid && !localStorage.getItem('token')) {
      localStorage.setItem('userid', userid);
      localStorage.setItem('token', token);
      console.log('Token and UserID saved to localStorage');
      navigate('/');
    }

    // setLoading(true);
    apiClient.get(url)
    .then((response) => {
      const transformedData = memoizedTransformData(response.data); // transformDataを使ってデータを変換
        setData(transformedData); // 変換したデータをstateにセット
    })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));

  }, [url, location, navigate, location.search]);

  return { data, loading, error };
};
export default useFetchData;

const backUrl = process.env.REACT_APP_API_URL;

const useFetchMyPage = () =>{
  return  useFetchData(`${backUrl}/api/mypage/`)
}

const useFetchContent = () => {
  return useFetchData(`${backUrl}/api/content`)
}

const useFetchChatList = () => {
  return useFetchData(`${backUrl}/api/chatroom_list/`)
}
const useFetchJob = () => {
  const location = useLocation();  // URLのクエリパラメータを監視
  const params = new URLSearchParams(location.search.toString());
  
  const url = params.toString() 
  ? `${backUrl}/api/job_allpost/?${params.toString()}` 
  : `${backUrl}/api/job_allpost/`;
  return useFetchData(url);
}

const useFetchShareHouse = () => {
  const location = useLocation();  // URLのクエリパラメータを監視
  const params = new URLSearchParams(location.search.toString());
  
  const url = params.toString() 
    ? `${backUrl}/api/sharehouse_allpost/?${params.toString()}`
    : `${backUrl}/api/sharehouse_allpost/`;
  return useFetchData(url); 
}

const useFetchShareHousePost = () => {
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const { postId } = useParams();
  const fetchId = id || postId

  const url = fetchId ? `${backUrl}/api/sharehouse_post/${fetchId}/` : `${backUrl}/api/sharehouse_post/0`;

  return useFetchData(url);

};

const useFetchTransactionPost = () => {
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const { postId } = useParams();
  const fetchId = id || postId
  const url = fetchId ? `${backUrl}/api/transaction_post/${fetchId}/` : `${backUrl}/api/transaction_post/0`;
  return useFetchData(url);
};

const useFetchJobPost = () => {
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const { postId } = useParams();
  const fetchId = id || postId
  const url = fetchId ? `${backUrl}/api/job_post/${fetchId}/` : `${backUrl}/api/job_post/0`;
  return useFetchData(url);
};


const useFetchTransaction = (formData) => {
  const location = useLocation();  // URLのクエリパラメータを監視
  const params = new URLSearchParams(location.search.toString());
  
  const url = params.toString() 
  ? `${backUrl}/api/transaction_allpost/?${params.toString()}` 
  : `${backUrl}/api/transaction_allpost/`;
  return useFetchData(url);
}
const useFetchCategory = () => useFetchData(`${backUrl}/api/cat/`, (data) => {
  const categoryData = {};
  data.forEach(item => {
    ['Room', 'Gender', 'Couple', 'Equipment', 'Things_cat', 'Maker', 'Eileage', 'Job_cat', 'English'].forEach(key => {
      if (item[key]) {
        categoryData[key.toLowerCase()] = item[key];
      }
    });
  });
  categoryData.sorting = [
    { id: '-timestampe', name: '投稿が新しい順' },
    { id: '-visitors', name: '注目度が高い順' },
    { id: 'cost',  name: '値段が安い順'},
    { id: 'rent', name: 'レントが安い順' },
    { id: 'available', name: '利用可能日が早い順' },
  ];
  console.log("Category Data:", categoryData);
  return categoryData;
});


export { 
  useFetchJob,
  useFetchJobPost,
  useFetchShareHouse, 
  useFetchShareHousePost,
  useFetchTransaction, 
  useFetchTransactionPost,
  useFetchCategory,
  useFetchChatList,
  useFetchMyPage,
  useFetchContent,
};